import { graphql } from 'react-relay';

export const jobsLoaderQuery = graphql`
  query JobsLoaderQuery($hospitalId: ID!, $numberOfOperatingRooms: Int!, $skip: Boolean!) {
    hospital(id: $hospitalId) @skip(if: $skip) {
      id
      name
      ...SurgeryTimelineFragment
    }
  }
`;
